<template>
  <view-section :title="$t('tags')">
    <div
      class="tw-flex lg:tw-flex-wrap tw-gap-2 tw-overflow-x-scroll lg:tw-overflow-x-auto"
    >
      <base-button
        v-for="({ name, key, localized }, index) in tags"
        :key="index"
        auto-width
        xsmall
        primary
        small-padding
        :read-only="!Settings.allowFiltering"
        class="tw-capitalize"
        @click="Settings.allowFiltering ? $emit('tag:filter', name) : null"
      >
        <span>{{ (localized || (key ? $t(key) : name)).toLowerCase() }}</span>
      </base-button>
    </div>
  </view-section>
</template>

<script>
import ViewSection from '@components/View/ViewSection.vue'
import { Settings } from '@config/game.js'

export default {
  components: {
    ViewSection,
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tag:filter'],
  setup() {
    return { Settings }
  },
}
</script>
